import { render, staticRenderFns } from "./DialogRotinasFavoritas.vue?vue&type=template&id=59e95dc2&scoped=true&"
import script from "./DialogRotinasFavoritas.vue?vue&type=script&lang=js&"
export * from "./DialogRotinasFavoritas.vue?vue&type=script&lang=js&"
import style0 from "./DialogRotinasFavoritas.vue?vue&type=style&index=0&id=59e95dc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e95dc2",
  null
  
)

export default component.exports